<template>
  <div>
    <q-card flat>
      <q-card-section>
        <div class="header">
          <q-btn
            :to="{
              name: 'CourseProfile',
              params: {
                courseId: this.course.id,
              },
            }"
            align="left"
            type="a"
            flat
            no-caps
            color="primary"
            padding="none"
            size="xl"
            class="text-h5"
            title="View full profile"
            @click="clickViewFullProfile"
            >{{ course.OLGDP001 }}</q-btn
          >
        </div>
        <div class="text-subtitle2">
          <span v-if="course.OLGDP026 !== PREMIUM_DATA_MASK">{{
            course.OLGDP026
          }}</span>
        </div>
        <div class="text-caption">{{ course.OLGDP021 }}</div>
        <div class="full-width row no-wrap items-start items-center">
          <div v-if="course.OLGDP027 !== PREMIUM_DATA_MASK">
            <span class="text-overline">{{ course.OLGDP027 }}</span>
          </div>
          <div>
            <q-chip
              class="inset-shadow"
              :color="colorComputed"
              :text-color="chipTextColorComputed"
              size="md"
              >{{ course.OLGDP003 }}</q-chip
            >
          </div>
        </div>
        <div class="q-mt-sm">
          <div class="q-gutter-sm">
            <q-btn
              :to="{
                name: 'CourseProfile',
                params: {
                  courseId: this.course.id,
                },
              }"
              type="a"
              label="View full profile"
              title="View full profile"
              color="primary"
              size="sm"
              icon="read_more"
              @click="clickViewFullProfile"
            ></q-btn>
            <q-btn
              :to="{
                name: 'UserCourseRating',
                params: {
                  courseId: this.course.id,
                },
              }"
              type="a"
              color="secondary"
              text-color="white"
              size="sm"
              :icon="isPremium ? 'rate_review' : 'lock'"
              title="Write a Review"
              label="Write a Review"
              @click="clickViewFullProfile"
              :disable="!isPremium"
            ></q-btn>
            <q-btn
              v-if="isInWishlist"
              color="amber-9"
              text-color="black"
              size="sm"
              :icon="isPremium ? 'flag' : 'lock'"
              title="Remove from Wishlist"
              label="Remove from Wishlist"
              @click="toggleInWishlist"
              :disable="!isPremium"
            ></q-btn>
            <q-btn
              v-else
              color="amber-5"
              text-color="black"
              size="sm"
              :icon="isPremium ? 'outlined_flag' : 'lock'"
              title="Add to Wishlist"
              label="Add to Wishlist"
              @click="toggleInWishlist"
              :disable="!isPremium"
            ></q-btn>
            <q-btn
              v-if="isInCoursesPlayed"
              color="green-9"
              size="sm"
              :icon="isPremium ? 'done' : 'lock'"
              title="Mark as not Played"
              label="Mark as not Played"
              @click="toggleCoursePlayed"
              :disable="!isPremium"
            ></q-btn>
            <q-btn
              v-else
              color="green-3"
              text-color="black"
              size="sm"
              :icon="isPremium ? 'done_outline' : 'lock'"
              title="Mark as Played"
              label="Mark as Played"
              @click="toggleCoursePlayed"
              :disable="!isPremium"
            ></q-btn>
            <q-btn
              v-if="course.OLGDP010"
              color="light-blue-1"
              text-color="black"
              type="a"
              :href="course.OLGDP010"
              title="Open Course Website"
              label="Open Course Website"
              target="_blank"
              rel="noopener noreferrer"
              size="sm"
              icon="link"
            ></q-btn>
          </div>
        </div>
      </q-card-section>
      <q-card-section>
        <div class="course-view">
          <CourseRatingSummary :course-id="course.id"></CourseRatingSummary>
          <div
            class="q-mt-sm course-view__category"
            v-for="(category, index) of filterCategories"
            :key="index"
          >
            <div class="text-subtitle1">{{ category }}</div>
            <div class="q-pb-sm">
              <span
                class="q-pb-sm text-subtitle2 dp-pair"
                v-for="dp in configGroupedByCategory[category]"
                :key="dp.name"
              >
                <span v-if="dp.name === 'OLGDP006'">
                  <span v-if="course['OLGDP006_formatted']">
                    <span class="text-weight-bold">{{ dp.label }}</span
                    >:
                    <span>{{ course["OLGDP006_formatted"] }}</span>
                  </span>
                </span>

                <span v-else-if="dp.name === 'OLGDP010'"> </span>

                <span v-else-if="course[dp.name] === 'Y'">
                  <span class="">{{ dp.label }}</span>
                  <q-icon name="check" class="text-green" size="16px" />
                </span>

                <span v-else-if="dp.name === 'OLGDP012' && course[dp.name]">
                  <span class="text-weight-bold">{{ dp.label }}</span
                  >:
                  <span v-if="course[dp.name] === PREMIUM_DATA_MASK">
                    <span title="Please login or register for an account."
                      ><q-icon name="lock"></q-icon
                    ></span> </span
                  ><span v-else>{{ course["OLGDP012_formatted"] }}</span>
                </span>

                <span v-else-if="dp.name === 'OLGDP091'">
                  <span
                    ><a
                      :href="course.OLGDP091"
                      target="_blank"
                      rel="noopener noreferrer"
                      >{{ dp.label }}</a
                    ></span
                  >
                </span>

                <span v-else-if="dp.name === 'OLGDP092' && course[dp.name]">
                  <span class="text-weight-bold">{{ dp.label }}</span
                  >:
                  <span v-if="course[dp.name] === PREMIUM_DATA_MASK">
                    <span title="Please login or register for an account."
                      ><q-icon name="lock"></q-icon
                    ></span> </span
                  ><span v-else>{{ course["OLGDP092_formatted"] }}</span>
                </span>

                <span v-else-if="dp.name === 'OLGDP093' && course[dp.name]">
                  <span class="text-weight-bold">{{ dp.label }}</span
                  >:
                  <span v-if="course[dp.name] === PREMIUM_DATA_MASK">
                    <span title="Please login or register for an account."
                      ><q-icon name="lock"></q-icon
                    ></span> </span
                  ><span v-else>{{ course["OLGDP093_formatted"] }}</span>
                </span>

                <span v-else-if="dp.name === 'OLGDP094' && course[dp.name]">
                  <span class="text-weight-bold">{{ dp.label }}</span
                  >:
                  <span v-if="course[dp.name] === PREMIUM_DATA_MASK">
                    <span title="Please login or register for an account."
                      ><q-icon name="lock"></q-icon
                    ></span> </span
                  ><span v-else>{{ course["OLGDP094_formatted"] }}</span>
                </span>

                <span v-else>
                  <span class="text-weight-bold">{{ dp.label }}</span
                  >:
                  <span v-if="course[dp.name] === PREMIUM_DATA_MASK">
                    <span title="Please login or register for an account."
                      ><q-icon name="lock"></q-icon
                    ></span> </span
                  ><span v-else>{{ course[dp.name] }}</span>
                </span>
              </span>
            </div>
          </div>
          <div class="q-mt-md">
            <q-btn
              outline
              rounded
              color="primary"
              size="sm"
              href="https://forms.gle/YrSqGwJuPrgodbV68"
              target="_blank"
              rel="noopener noreferrer"
              type="a"
              label="Suggest an Update"
            ></q-btn>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
import camelCase from "lodash/camelCase";
import groupBy from "lodash/groupBy";
import { mapGetters } from "vuex";
import { PREMIUM_DATA_MASK } from "@/constants";
import CourseRatingSummary from "@/components/CourseRatingSummary.vue";

export default {
  name: "CourseView",
  components: {
    CourseRatingSummary,
  },
  props: {
    course: {
      required: true,
      type: Object,
      default() {
        return {};
      },
    },
    datapoints: {
      required: true,
      type: Array,
      default() {
        return [];
      },
    },
    wishlistCourseIds: {
      required: false,
      type: Array,
      default() {
        return [];
      },
    },
    coursePlayedCourseIds: {
      required: false,
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      loading: false,
      loadError: null,
      courseTypeColorMap: {
        muni: "purple-8",
        public: "green-8",
        private: "red-8",
        resort: "blue-8",
        semiPrivate: "yellow-8",
      },
    };
  },
  beforeCreate() {
    this.PREMIUM_DATA_MASK = PREMIUM_DATA_MASK;
  },
  mounted() {},
  computed: {
    ...mapGetters(["isPremium"]),
    courseViewColumnsConfig() {
      return this.datapoints
        .filter(
          datapoint =>
            datapoint.id !== "OLGDP001" &&
            datapoint.id !== "OLGDP003" &&
            datapoint.id !== "OLGDP026" &&
            datapoint.id !== "OLGDP027",
        )
        .filter(datapoint => Boolean(this.course[datapoint.id]))
        .map(dataPoint => {
          return {
            category: dataPoint.category,
            name: dataPoint.id,
            label: dataPoint.label,
          };
        });
    },
    configGroupedByCategory() {
      return groupBy(this.courseViewColumnsConfig, "category");
    },
    filterCategories() {
      return Object.keys(this.configGroupedByCategory);
    },
    isInWishlist() {
      return this.wishlistCourseIds.includes(this.course.id);
    },
    isInCoursesPlayed() {
      return this.coursePlayedCourseIds.includes(this.course.id);
    },
    courseTypeId() {
      return camelCase(this.course.OLGDP003);
    },
    colorComputed() {
      return this.courseTypeColorMap[this.courseTypeId];
    },
    chipTextColorComputed() {
      const dark = this.courseTypeId === "semiPrivate";
      return dark ? "" : "white";
    },
  },
  methods: {
    getDatapointById(id) {
      return this.datapoints.find(dp => dp.id === id);
    },
    toggleInWishlist() {
      this.$emit("toggle-wishlist", this.course.id);
    },
    toggleCoursePlayed() {
      this.$emit("toggle-course-played", this.course.id);
    },
    clickViewFullProfile() {
      this.$store.commit("setClickedCourseId", "");
    },
  },
};
</script>
}<style lang="scss" scoped>
.header {
  font-family: Georgia, "Times New Roman", Times, serif;
}

.dp-pair {
  margin-right: 14px;
}
</style>
